<template>
  <div>
    <h2 class="step-name">Sheep - General</h2>

    <div class="step-section">
      <h3>Fly and Lice</h3>
      <discussion-points
        title="Sheep - Fly and Lice"
        comments-field="sheep_fly_and_lice"
        points="Fly and Lice treatments (prevention/treatment), Issues (age effected, when)"
      >
      </discussion-points>

      <discussion-points title="" points="Product, price (if discussed), any other information to help retail">
        <radio-input
          label="Are you interested in further discussion fly and lice management"
          field-name="sheep_wants_fly_lice_treat"
          :add-email-notification="true"
          @on-change="
            updateRequiredFields($event)
            toggleNotifications($event)
          "
          :add-comment="true"
          :choices="[
            { value: 'Yes', display: 'Yes' },
            { value: 'No', display: 'No' },
          ]"
        >
        </radio-input>
        <text-area
          v-if="getFieldValue('sheep_wants_fly_lice_treat') == 'Yes'"
          label="Additional information for retail - e.g. Month, Product"
          field-name="sheep_wants_fly_lice_treat_notes"
          :required="Boolean(getFieldValue('sheep_wants_fly_lice_treat') == 'Yes')"
          @on-change="checkAndCompleteStep"
        >
        </text-area>
      </discussion-points>
    </div>

    <div class="step-section">
      <h3>Sheep - Infections</h3>
      <h3>Sheep antibiotic/NSAID purchases</h3>
      <table class="table table-bordered">
        <thead>
          <tr>
            <th>Purchase Date</th>
            <th>Animal Name</th>
            <th>Stock Code - Name</th>
            <th>Quantity</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in getChartData('sheep_antibiotic_purchases')" :key="index">
            <td class="text-left">{{ row['Purchase Date'] }}</td>
            <td class="text-left">{{ row['Animal Name'] }}</td>
            <td class="text-left">{{ row['Stock Code - Name'] }}</td>
            <td class="text-left">{{ row['Quantity'] }}</td>
          </tr>
        </tbody>
      </table>
      <discussion-points
        title="Infections/NSAIDs"
        comments-field="infections"
        points="Foot rot, watery mouth, navel ill, joint infections, bearings, pink eye, scouring, NSAIDs"
      >
      </discussion-points>
    </div>

    <div class="step-section">
      <h3>Sheep Services</h3>
      <radio-input
        label="Do you want an animal health plan / calendar"
        field-name="sheep_wants_health_plan"
        :add-email-notification="true"
        @on-change="toggleNotifications"
        :add-comment="true"
        :choices="[
          { value: 'Yes', display: 'Yes' },
          { value: 'No', display: 'No' },
        ]"
      >
      </radio-input>

      <discussion-points
        title="Animal Health Planning Discussion Points"
        comments-field="sheep_wants_health_plan_discussion"
        points="Start of lambing, start of tailing, shearing, start of weaning"
      >
      </discussion-points>

      <programme-input programme-slug="ovigold"></programme-input>
    </div>
  </div>
</template>

<script>
import baseComponent from '@/mixins/base_consult_component_v2'
import { mapMutations } from 'vuex'

export default {
  name: 'SheepGeneral',
  mixins: [baseComponent],
  methods: {
    ...mapMutations('currentConsult', ['addRequiredFields', 'removeRequiredFields']),
    validate: function () {
      if (
        this.getFieldValue('sheep_wants_fly_lice_treat') == 'Yes' &&
        !this.getFieldValue('sheep_wants_fly_lice_treat_notes')
      ) {
        return false
      }
      return true
    },
    updateRequiredFields: function ({ fieldName, value }) {
      let requiredField = { value: fieldName, stepName: this.$options.name }
      if (value == 'Yes') {
        this.addRequiredFields(requiredField)
      } else {
        this.removeRequiredFields(requiredField)
      }
      this.checkAndCompleteStep()
    },
    toggleNotifications: function () {
      this.setEmailNotification({
        slug: 'do-you-want-an-animal-health-plan-calendar',
        value: this.getFieldValue('sheep_wants_health_plan', this.$options.name) == 'Yes' ? true : false,
      })

      this.setEmailNotification({
        slug: 'are-you-interested-in-preventive-treatment-for-fly-and-lice',
        value: this.getFieldValue('sheep_wants_fly_lice_treat', this.$options.name) == 'Yes' ? true : false,
      })
    },
  },
}
</script>
